<ng-container *ngIf="
    properties.chartType === 1 ||
      properties.chartType === 2 ||
      properties.chartType === 3;
    else basicChart
  ">
  <div>
    <div id="{{ properties.divId }}" class="full-width full-height"></div>
    <div class="speedometer-labels">
      <span class="label-unit">{{ properties.value }} {{ properties.unitLabel }}</span>
      <span class="label-description">{{ properties.descriptionLabel }}</span>
    </div>
  </div>
</ng-container>

<ng-template #basicChart>
  <div class="full-width full-height template-graph">
    <div class="basic-chart-container">
      <img src='{{icon}}' alt="Velocimetro" class="icon-velocimeter" />
      <!-- <img [attr.src]="
        properties.chartType === 4
          ? '/assets/charts/tacometro.svg'
          : '/assets/charts/concordans.svg'
      " alt="Velocimetro" class="icon-velocimeter" /> -->
      <div class="hand-clock" [style.transform]="
        'rotate(' +
        (properties.handClockRotation !== undefined
          ? properties.handClockRotation
          : properties.value) +
        'deg)'
      " [ngStyle]="backgroundImageStyle">
      </div>
    </div>
    <div *ngIf="!properties.hideLabel" class="speedometer-labels text-white" [ngClass]="
        properties.labelsClass !== undefined ? properties.labelsClass : ''
      ">
      <div class="label-container">
        <span class="label-unit text-sm-size-18" [ngClass]="
            properties.unitLabelClass !== undefined
              ? properties.unitLabelClass
              : ''
          ">{{ properties.value }} {{ properties.unitLabel }}</span>

          <ng-container *ngIf="
              properties.descriptionLabel !== '' &&
              properties.descriptionLabel !== undefined
            ">
            <span class="label-description text-sm-size-16">{{
              properties.descriptionLabel
              }}</span>
          </ng-container>
      </div>
    </div>
  </div>
</ng-template>
